<template>
  <div class="business-tenant-form">
    <el-dialog
      title="新增企业合同"
      :close-on-click-modal="false"
      @close="close"
      visible
      :before-close="close"
    >
      <div class="business-form">
        <div class="step-content">
          <el-steps
            :center="true"
            class="el-steps"
            :align-center="true"
            :space="230"
            :active="steps"
            finish-status="finish"
          >
            <el-step title="基本信息"></el-step>
            <el-step title="合同条款"></el-step>
            <el-step
              :status="steps >= 3 ? '' : 'process'"
              title="物业交割"
            ></el-step>

            <el-step
              :status="steps >= 4 ? '' : 'process'"
              title="其他信息"
            ></el-step>
          </el-steps>
        </div>
        <!-- 表单主体 -->
        <div class="form-content">
          <el-form
            inline
            ref="businessFormData"
            :rules="rules"
            :model="businessFormData"
            label-width="136px"
            label-position="right"
          >
            <!-- 第一步 -->
            <KeepAlive>
            <el-row v-if="steps === 1">
              <el-row class="form-line">
                <el-col :span="20">
                  <el-form-item
                    label="企业信息"
                    class="all-line"
                    prop="userName"
                  >
                    <el-select
                      v-model="businessFormData.tenantId"
                      filterable
                      remote
                      class="inline-input"
                      placeholder="搜索选择企业"
                      :remote-method="companyInformSearch"
                      :loading="companyLoading"
                      @change="val => companySelect(val, options4)"
                    >
                      <el-option
                        v-for="item in options4"
                        :key="item.id"
                        :label="item.username + ' ' + item.phone"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <span class="new-company" @click="addNewCompany('addCompany')"
                    >新增企业</span
                  >
                </el-col>
              </el-row>
              <el-row class="form-line">
                <el-col :span="12">
                  <el-form-item
                    label="起租时间"
                    class="half-line"
                    prop="startTime"
                  >
                    <el-date-picker
                      class="half-item"
                      v-model="businessFormData.startTime"
                      :picker-options="pickerOptions0"
                      type="date"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="租期时长"
                    class="half-line"
                    prop="timeRange"
                  >
                    <el-select
                      class="half-item"
                      v-model="businessFormData.timeRange"
                    >
                      <el-option
                        v-for="(item, index) in rentTime"
                        :key="index"
                        :value="item.id"
                        :label="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="form-line">
                <el-col :span="12">
                  <el-form-item
                    label="退租时间"
                    class="half-line"
                    prop="endTime"
                  >
                    <el-date-picker
                      :disabled="true"
                      class="half-item"
                      v-model="businessFormData.endTime"
                      type="date"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="支付周期" class="half-line" prop="cycle">
                    <el-select
                      class="half-item"
                      v-model="businessFormData.cycle"
                    >
                      <el-option
                        v-for="(item, index) in payCycle"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="form-line">
                <el-col :span="24">
                  <el-form-item
                    label="房间选择"
                    class="all-line"
                    prop="houseSelect"
                  >
                    <el-button
                      type="primary"
                      @click="addNewCompany('houseSelect')"
                      >点击选择房间</el-button
                    >
                    <span class="house-change-word"
                      >注: 只能签同一个小区/社区</span
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="form-line">
                <el-col :span="24">
                  <el-form-item
                    label="已选择房间"
                    class="table-line"
                    prop="houseChangedList"
                  >
                    <el-table :data="businessFormData.selectedHouseList">
                      <el-table-column label="房间号" width="100">
                        <template slot-scope="scope">
                          <div>{{ houseNumber(scope.row) }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="delegateEndTime"
                        label="房东合同到期日"
                        ><template slot-scope="scope">
                          <span>{{
                            scope.row.delegateEndTime | dateFormat
                          }}</span>
                        </template></el-table-column
                      >
                      <el-table-column
                        :formatter="dealMoney"
                        prop="monthPrice"
                        label="规则租金"
                        width="120"
                      ></el-table-column>
                      <el-table-column
                        :formatter="dealMoney"
                        prop="firstCutPrice"
                        label="规则首期减免额"
                      ></el-table-column>
                      <el-table-column
                        :formatter="dealMoney"
                        prop="frontMoneyAmount"
                        label="定金金额"
                        width="120"
                      ></el-table-column>
                      <el-table-column label="最多可居住人数">
                        <template slot-scope="scope">
                          <p>
                            <el-input
                              class="price-input"
                              v-model="scope.row.livesNumber"
                            ></el-input
                            >&nbsp;<span class="price-input-unit">人</span>
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                          <el-button
                            @click="deleteRow(scope.$index, scope.row)"
                            class="button-color"
                            type="text"
                            size="small"
                            >删除</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                    <!-- 总计和房间数和定金总价 -->
                    <div class="total-info">
                      <div>
                        总计:
                        <span class="total-info-num">{{
                          businessFormData.selectedHouseList.length
                        }}</span
                        >间房
                      </div>
                      <div>
                        定价总额:
                        <span class="total-info-num">{{
                          getNewPrices('monthPrice')
                        }}</span
                        >元
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
            </KeepAlive>
            <!-- 第二步 -->
            <el-row v-if="steps === 2">
              <el-row class="form-line">
                <el-col :span="24">
                  <el-form-item
                    label="已选择房间"
                    class="table-line"
                    prop="houseSelectedPrice"
                  >
                    <el-table :data="businessFormData.selectedHouseList">
                      <el-table-column label="房间号" width="100">
                        <template slot-scope="scope">
                          <div>{{ houseNumber(scope.row) }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :formatter="dealMoney"
                        width="120"
                        prop="monthPrice"
                        label="规则租金"
                      ></el-table-column>
                      <el-table-column
                        :formatter="dealMoney"
                        width="120"
                        prop="firstCutPrice"
                        label="规则首期减免"
                      ></el-table-column>
                      <el-table-column label="实际签约价">
                        <template slot-scope="scope">
                          <p>
                            <el-input
                              :disabled="adjustPrice"
                              @blur="
                                changeActuallyMonthPrice(
                                  scope.row,
                                  scope.$index
                                )
                              "
                              class="price-input"
                              v-model="scope.row.actuallyMonthPrice"
                            ></el-input
                            >&nbsp;<span class="price-input-unit">元/月</span>
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :formatter="dealMoney"
                        width="100"
                        prop="monthPriceDiff"
                        label="租金差价"
                      ></el-table-column>
                      <el-table-column label="实际首期减免">
                        <template slot-scope="scope">
                          <p>
                            <el-input
                              :disabled="adjustPrice"
                              @blur="
                                changeActuallyFirstCutPrice(
                                  scope.row,
                                  scope.$index
                                )
                              "
                              class="price-input"
                              v-model="scope.row.actuallyFirstCutPrice"
                            ></el-input
                            >&nbsp;<span class="price-input-unit">元/月</span>
                          </p>
                        </template>
                      </el-table-column>
                    </el-table>
                    <!-- 总计和房间数和定金总价 -->
                    <div class="total-info">
                      <div>
                        总计:
                        <span class="total-info-num">{{
                          businessFormData.selectedHouseList.length
                        }}</span
                        >间房
                      </div>
                      <div>
                        <el-button
                          type="primary"
                          class="adjust-button"
                          @click="adjustPrices"
                          >{{
                            adjustPrice ? '调整房租' : '确认调整'
                          }}</el-button
                        >
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="separate-line"></el-row>
              <!-- 各种 汇总价格表单 -->
              <el-row class="form-line">
                <el-col :span="12">
                  <el-form-item
                    label="规则租金总价"
                    class="half-line"
                    prop="totalRuleRent"
                  >
                    <el-input
                      :disabled="true"
                      class="form-item-input"
                      v-model="businessFormData.totalRuleRent"
                    ></el-input>
                    <span class="price-unit">元/月</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="实际签约总价"
                    class="half-line"
                    prop="totalRental"
                  >
                    <el-input
                      :disabled="true"
                      v-model="businessFormData.totalRental"
                    ></el-input>
                    <span class="price-unit">元/月</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="form-line">
                <el-col :span="12">
                  <el-form-item
                    label="打折比例"
                    class="half-line"
                    prop="rentDiscount"
                  >
                    <el-input
                      :disabled="adjustPrice"
                      @blur="changeRentDiscount"
                      v-model="businessFormData.rentDiscount"
                    ></el-input>
                    <span class="price-unit">%</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="总租金差价"
                    class="half-line"
                    prop="rentDifferential"
                  >
                    <el-input
                      :disabled="true"
                      v-model="businessFormData.rentDifferential"
                    ></el-input>
                    <span class="price-unit">元/月</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="form-line">
                <el-col :span="12">
                  <el-form-item
                    label="规则首期总减免额"
                    class="half-line"
                    prop="totalFirstCut"
                  >
                    <el-input
                      :disabled="true"
                      v-model="businessFormData.totalFirstCut"
                    ></el-input>
                    <span class="price-unit">元</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="实际首期总减免额"
                    class="half-line"
                    prop="actulaTotalRuleRent"
                  >
                    <el-input
                      :disabled="true"
                      v-model="businessFormData.actulaTotalRuleRent"
                    ></el-input>
                    <span class="price-unit">元</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="form-line">
                <el-col :span="12">
                  <el-form-item
                    label="押金收取比例"
                    class="half-line"
                    prop="totalDepositProportion"
                  >
                    <el-radio-group
                      @change="changeDepositConfirm"
                      v-model="businessFormData.totalDepositProportion"
                    >
                      <!-- <el-radio-button label="1">1倍租金</el-radio-button>
                      <el-radio-button label="1.5">1.5倍租金</el-radio-button> -->
                      <el-radio-button
                      v-for="(item, index) in depositMultiples"
                      :key="index"
                      :label="item.id"
                      v-show="String(item.id) !== String(defaultDeposit)"
                      >{{ item.name }}</el-radio-button
                    >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="押金总额"
                    class="half-line"
                    prop="totalDeposit"
                  >
                    <el-input
                      :disabled="true"
                      v-model="businessFormData.totalDeposit"
                    ></el-input>
                    <span class="price-unit">元</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
            <el-row v-if="steps === 3">
              <el-row class="line-title">
                <el-col :span="9">房源名称</el-col>
                <el-col :span="7">状态</el-col>
                <el-col :span="8">操作</el-col>
              </el-row>
              <el-row
                class="step3-line"
                v-for="(item, index) in businessFormData.selectedHouseList"
                :key="index"
              >
                <el-col :span="9">{{ houseName(item) }}</el-col>
                <el-col :span="4">
                  <div v-if="item.articlesLists.length">
                    <span class="status-green"></span>
                    <span class="status-word">已添加</span>
                  </div>
                  <div v-else>
                    <span class="status-red"></span>
                    <span class="status-word">未添加</span>
                  </div>
                </el-col>
                <el-col :span="11">
                  <el-button @click="openJJ(item, index)"
                    >添加能耗详情</el-button
                  >
                  <el-button @click="openKK(item, index)"
                    >添加物业交割清单</el-button
                  >
                </el-col>

                <el-col
                  :span="24"
                  v-if="item.__visible['energyForm']"
                  style="padding:16px; background-color:#fbfdff; box-shadow:inset 0 2px 0 #f4f4f4;"
                >
                  <div>
                    <energy-form
                      :energyConsumption.sync="item.energyConsumption"
                      @close="item.__visible['energyForm'] = false"
                    />
                  </div>
                </el-col>

                <el-col
                  :span="24"
                  v-if="item.__visible['manifest']"
                  style="padding:16px; background-color:#fbfdff; box-shadow:inset 0 2px 0 #f4f4f4;"
                >
                  <div>
                    <manifest
                      :data.sync="item.articlesLists"
                      @close="item.__visible['manifest'] = false"
                    />
                  </div>
                </el-col>
              </el-row>
            </el-row>
            <el-row v-if="steps === 4">
              <el-row class="form-line">
                <el-col :span="24">
                  <el-form-item label="其他费用" class="all-line" prop="">
                    <!-- <el-button type="primary" @click="addPropertyFee">{{
                      propertyShow ? '删除物管费' : '增加物管费'
                    }}</el-button> -->
                    <el-button type="primary" @click="addNetworkFee">{{
                      netWorkShow ? '删除网络费' : '增加网络费'
                    }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="form-line">
                <el-col :span="12" v-if="propertyShow">
                  <el-form-item
                    label="物管费支付方式"
                    class="half-line"
                    prop="wyCycle"
                  >
                    <el-select
                      class="half-item"
                      v-model="businessFormData.wyCycle"
                      placeholder="请选择物管费支付方式"
                    >
                      <el-option
                        v-for="(item, index) in options2"
                        :key="index"
                        :value="item.id"
                        :label="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="netWorkShow">
                  <el-form-item
                    label="网络费支付方式"
                    class="half-line"
                    prop="wlCycle"
                  >
                    <el-select
                      class="half-item"
                      v-model="businessFormData.wlCycle"
                      placeholder="请选择网络费支付方式"
                    >
                      <el-option
                        v-for="(item, index) in options2"
                        :key="index"
                        :value="item.id"
                        :label="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="form-line" v-if="netWorkShow || propertyShow">
                <el-col :span="24">
                  <el-form-item
                    label="已选择房间"
                    class="table-line"
                    prop="wyAndwl"
                  >
                    <el-table :data="businessFormData.selectedHouseList">
                      <el-table-column label="房间号">
                        <template slot-scope="scope">
                          <div>{{ houseNumber(scope.row) }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column label="物管费" v-if="propertyShow">
                        <template slot-scope="scope">
                          <p>
                            <el-input
                              disabled
                              @blur="changeNum(scope.row, 'wyNum')"
                              class="price-input"
                              v-model="scope.row.wyNum"
                            ></el-input
                            >&nbsp;<span class="price-input-unit">元/月</span>
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column label="网络费" v-if="netWorkShow">
                        <template slot-scope="scope">
                          <p>
                            <el-input
                              @blur="changeNum(scope.row, 'wlNum')"
                              class="price-input"
                              v-model="scope.row.wlNum"
                            ></el-input
                            >&nbsp;<span class="price-input-unit">元/月</span>
                          </p>
                        </template>
                      </el-table-column>
                    </el-table>
                    <!-- 总计和房间数和定金总价 -->
                    <div class="total-info">
                      <div>
                        总计:
                        <span class="total-info-num">{{
                          businessFormData.selectedHouseList.length
                        }}</span
                        >间房
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="separate-line"></el-row>
              <el-row class="form-line">
                <el-col :span="12" v-if="propertyShow">
                  <el-form-item
                    label="物管费总金额"
                    class="half-line"
                    prop="perfeeTotalAmount"
                  >
                    <el-input
                      :disabled="true"
                      v-model="businessFormData.perfeeTotalAmount"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="netWorkShow">
                  <el-form-item
                    label="网络费总金额"
                    class="half-line"
                    prop="netWorkTotalAmount"
                  >
                    <el-input
                      :disabled="true"
                      v-model="businessFormData.netWorkTotalAmount"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="form-line">
                <el-col :span="24">
                  <el-form-item
                    label="能耗费支付方"
                    class="half-line"
                    prop="feeTypeEnumPaySubjectMap"
                  >
                    <el-radio-group
                      v-model="businessFormData.feeTypeEnumPaySubjectMap"
                    >
                      <el-radio-button label="SIGNATORY"
                        >签约人</el-radio-button
                      >
                      <el-radio-button label="INPERSON">入住人</el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="form-line">
                <el-col :span="12">
                  <el-form-item
                    label="租客来源"
                    class="half-line"
                    prop="source"
                  >
                    <el-select
                      class="half-item"
                      v-model="businessFormData.source"
                    >
                      <el-option
                        v-for="(item, index) in source"
                        :key="index"
                        :value="item.id"
                        :label="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="销售人员"
                    class="half-line"
                    prop="people"
                  >
                    <el-cascader
                      class="half-item"
                      v-model="businessFormData.people"
                      placeholder="销售人员"
                      :options="options22"
                      @change="changeHouseKeeper"
                      :props="props"
                      :show-all-levels="false"
                    ></el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row class="form-line">
                <el-col :span="24">
                  <el-form-item label="备注" class="all-line" prop="">
                    <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="businessFormData.memo"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-row>
          </el-form>
          <!-- 下一步按钮 -->
          <div class="footer">
            <el-button v-if="steps > 1" @click="toLastStep('businessFormData')"
              >上一步</el-button
            >
            <el-button
              type="primary"
              :loading="isLoading"
              @click="toNextStep('businessFormData')"
              >{{ steps === 4 ? '提交' : '下一步' }}</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  stepList,
  lineNumber,
  houseList,
  rentTime,
  payCycle,
  options2,
  source,
} from './enum.js'
// import { dealWithBlank } from '@/components/forms/AddBussinessForm/enum.js'
import accountApi from '@/xhr/services/account'
import contractApi from '@/xhr/services/contract'
import saleRuleApi from '@/xhr/services/saleRule'
import version from '@/dd_version';
import Vue from 'vue'
import EnergyForm from '@/components/forms/ReletContractForm/EnergyForm'
import Manifest from '@/components/forms/ReletContractForm/Manifest'
import { extendHouseRow, isTableEditing } from './utils'
import { dateFormat } from '@/filters'
import { listHouseAssets } from './fetch'
import calendar from 'solarday2lunarday'
import { validateWater } from './free'
import { getConfigList } from 'src/components/forms/ReletContractForm/fetch'
import { filterCycleOptions } from './strategy'
import Lunar from '../../common/lunar2solar'
import houseApi from '@/xhr/services/house'

Vue.component('my-item-zh', {
  functional: true,
  render: function(h, ctx) {
    var item = ctx.props.item
    return h('li', ctx.data, [
      h('div', { attrs: { class: 'business-contract-add' } }, [
        h('div', { attrs: { class: 'username' } }, [item.username]),
        h('div', { attrs: { class: 'legalName' } }, [item.legalName]),
      ]),
    ])
  },
  props: {
    item: { type: Object, required: true },
  },
})
export default {
  data() {
    var houseSelect = (rule, value, callback) => {
      if (!this.businessFormData.selectedHouseList.length) {
        callback('请点击选择房间')
      } else {
        callback()
      }
    }
    var getHouseList = (rule, value, callback) => {
      let errorArr = []
      this.businessFormData.selectedHouseList.forEach(item => {
        if (item.livesNumber && Number(item.livesNumber) > 0) {
          errorArr.push(true)
        } else {
          errorArr.push(false)
        }
      })
      if (errorArr.includes(false)) {
        errorArr.forEach((item, index) => {
          if (!item) {
            let row = this.businessFormData.selectedHouseList[index]
            let houseNumber = this.houseNumber(row)
            callback(`请正确填写${houseNumber}房间的最多可居住人数`)
            return
          }
        })
      } else {
        callback()
      }
    }
    var setTimeRange = (rule, value, callback) => {
      let { timeRange, cycle } = this.businessFormData
      if (!timeRange) {
        callback('请选择租期时长')
      } else if (timeRange < 6) {
        if (cycle === 'SIXMON' || cycle === 'TWELVEMON') {
          this.businessFormData.cycle = ''
        }
        callback()
      } else if (timeRange < 12) {
        if (cycle === 'TWELVEMON') {
          this.businessFormData.cycle = ''
        }
        callback()
      } else {
        callback()
      }
    }
    var setCycle = (rule, value, callback) => {
      let { timeRange, cycle } = this.businessFormData
      if (!cycle) {
        callback('请选择支付周期')
      } else if (timeRange && timeRange < 6) {
        if (cycle === 'SIXMON' || cycle === 'TWELVEMON') {
          this.businessFormData.cycle = ''
        }
        callback()
      } else if (timeRange && timeRange < 12) {
        if (cycle === 'TWELVEMON') {
          this.businessFormData.cycle = ''
        }
        callback()
      } else {
        callback()
      }
    }
    var houseSelected = (rule, value, callback) => {
      let emptyMonthPriceArr = this.businessFormData.selectedHouseList.filter(
        item => !item.actuallyMonthPrice
      )
      let emptyFirstMonthPriceArr = this.businessFormData.selectedHouseList.filter(
        item => !item.actuallyFirstCutPrice
      )
      let errorArr = []
      this.businessFormData.selectedHouseList.forEach(item => {
        let actuallyMonthPrice = Number(item.actuallyMonthPrice)
        let actuallyFirstCutPrice = Number(item.actuallyFirstCutPrice)
        if (
          (actuallyMonthPrice * Number(item.firstCutDiscount)) / 100 <
          actuallyFirstCutPrice
        ) {
          errorArr.push(false)
        } else {
          errorArr.push(true)
        }
      })
      if (emptyMonthPriceArr.length) {
        callback('请将实际签约价填写完整')
      } else if (emptyFirstMonthPriceArr.length) {
        callback('请将实际首期减免填写完整')
      } else if (errorArr.includes(false)) {
        errorArr.forEach((item, index) => {
          if (!item) {
            let row = this.businessFormData.selectedHouseList[index]
            let houseNumber = this.houseNumber(row)
            let firstCutDiscount = row.firstCutDiscount
            callback(
              `${houseNumber}实际首期减免额不可以大于实际签约价的${firstCutDiscount}%`
            )
            return
          }
        })
      } else {
        callback()
      }
    }
    var getRentDiscount = (rule, value, callback) => {
      if (!value) {
        callback('请填写打折比例')
      } else if (typeof value === 'string' || typeof value === 'number') {
        callback()
      }
    }
    var setWyCycle = (rule, value, callback) => {
      let { timeRange, wyCycle } = this.businessFormData
      console.log(wyCycle)
      if (!wyCycle) {
        callback('请选择物管费支付方式')
      } else if (timeRange && timeRange < 6) {
        if (wyCycle === 'SIXMON' || wyCycle === 'TWELVEMON') {
          this.businessFormData.wyCycle = ''
        }
        callback()
      } else if (timeRange && timeRange < 12) {
        if (wyCycle === 'TWELVEMON') {
          this.businessFormData.wyCycle = ''
        }
        callback()
      } else {
        callback()
      }
    }
    var setWlCycle = (rule, value, callback) => {
      let { timeRange, wlCycle } = this.businessFormData
      console.log(wlCycle)
      if (!wlCycle) {
        callback('请选择网络费支付方式')
      } else if (timeRange && timeRange < 6) {
        if (wlCycle === 'SIXMON' || wlCycle === 'TWELVEMON') {
          this.businessFormData.wlCycle = ''
        }
        callback()
      } else if (timeRange && timeRange < 12) {
        if (wlCycle === 'TWELVEMON') {
          this.businessFormData.wlCycle = ''
        }
        callback()
      } else {
        callback()
      }
    }
    var wyAndwlChecked = (rule, value, callback) => {
      let wyArr = this.businessFormData.selectedHouseList.filter(
        item => !item.wyNum && item.wyNum !== 0
      )
      let wlArr = this.businessFormData.selectedHouseList.filter(
        item => !item.wlNum
      )
      if (this.propertyShow && wyArr.length) {
        callback('请填写各个房间的物管费')
      } else if (this.netWorkShow && wlArr.length) {
        callback('请填写各个房间的网络费')
      } else {
        callback()
      }
    }
    // var getFeeTypeEnumPaySubjectMap = (rule, value, callback) => {
    //   if (!value) {
    //     callback('请选择能耗费支付方')
    //   } else {
    //     callback()
    //   }
    // }
    this.canCreate = true

    return {
      houseSpaceIdList: [],
      pickerOptions0: {
        disabledDate(time) {
          return (
            time.getTime() < Date.now() - 30 * 24 * 3600000 ||
            time.getTime() > Date.now() + 7 * 24 * 3600000
          )
        },
      },
      steps: 1,
      stepList,
      lineNumber,
      houseList,
      rentTime,
      payCycle,
      options2,
      source,
      options22: JSON.parse(this.$store.state.currentUser.keeperData), // 销售人员

      adjustPrice: true, // 调价开关
      addCompanyShow: false,
      businessFormData: {
        userName: '',
        startTime: '',
        endTime: '',
        firstMonthEndTime: '', // 首月结束时间
        cycle: '',
        totalEarnest: '', // 定金总金额
        timeRange: '',
        userPhone: '',
        userId: '',
        loginId: this.$store.state.currentUser.uid,
        selectedHouseList: [],
        // houseAndConfigBeanList: [],    // 子合同信息数组
        totalRuleRent: '', // 规则租金总价
        totalRental: '', // 签约总价
        rentDiscount: '', //  打折比例
        rentDifferential: '', // 总租金差价
        totalFirstCut: '', // 规则首期总减免额
        actulaTotalRuleRent: '', // 实际首期总减免额
        totalDepositProportion: '', // 押金收取比例
        totalDeposit: '', // 押金总额
        signType: 'NEW',
        tenantType: 'COMMON',
        contractType: 'RENT',
        source: '',
        feeTypeEnumPaySubjectMap: 'SIGNATORY',
        perfeeTotalAmount: '',
        netWorkTotalAmount: '',
        people: [],
        houseKeeperId: '', // 销售Id
        housekeeperName: '',
        housekeeperPhone: '',
        enterId: '', // 录入人Id
        memo: '',
        wlCycle: '',
        wyCycle: '',
      }, // 要上传的合同表单数据
      tenantId: '', // 企业租客ID
      waiter: null,

      propertyShow: false,
      netWorkShow: false,
      props: {
        value: 'label',
        children: 'cities',
      },
      earnestArr: [], // 定金总额
      isLoading: false, // 提交开关
      options4: [],
      companyLoading: false,
      // 校验规则
      rules: {
        userName: [
          { required: true, message: '请选择选择企业信息', trigger: 'blur' },
        ],
        startTime: [
          {
            type: 'date',
            required: true,
            message: '请选择起租时间',
            trigger: 'change',
          },
        ],
        endTime: [
          {
            type: 'date',
            required: true,
            message: '请选择退租字段',
            trigger: 'change',
          },
        ],
        cycle: [{ required: true, validator: setCycle, trigger: 'change' }],
        timeRange: [
          { required: true, validator: setTimeRange, trigger: 'change' },
        ],
        houseSelect: [{ required: true, validator: houseSelect }],
        houseChangedList: [{ required: true, validator: getHouseList }],

        houseSelectedPrice: [{ required: true, validator: houseSelected }],
        totalRuleRent: [
          { required: true, message: '请获取规则租金总价', trigger: 'blur' },
        ],
        totalRental: [
          { required: true, message: '请获取实际签约总价', trigger: 'blur' },
        ],
        rentDiscount: [
          { required: true, validator: getRentDiscount, trigger: 'blur' },
        ],
        rentDifferential: [
          { required: true, message: '请获取总租金差价', trigger: 'blur' },
        ],
        totalFirstCut: [
          {
            required: true,
            message: '请获取规则首期总减免额',
            trigger: 'blur',
          },
        ],
        actulaTotalRuleRent: [
          {
            required: true,
            message: '请获取实际首期总减免额',
            trigger: 'blur',
          },
        ],
        // totalDepositProportion: [
        //   { required: true, message: '请选择押金收取比例', trigger: 'change' },
        // ],
        // totalDeposit: [
        //   { required: true, message: '请填写打折比例', trigger: 'blur' },
        // ],

        wyCycle: [{ required: true, validator: setWyCycle, trigger: 'change' }],
        wlCycle: [{ required: true, validator: setWlCycle, trigger: 'change' }],
        wyAndwl: [
          { required: true, validator: wyAndwlChecked, trigger: 'blur' },
        ],
        source: [
          { required: true, message: '请选择租客来源', trigger: 'change' },
        ],
        people: [
          {
            type: 'array',
            required: true,
            message: '请选择销售人员',
            trigger: 'change',
          },
        ],

        // perfeeTotalAmount: [{required: true, message: '请获取物管费总金额', trigger: 'blur'}],
        // netWorkTotalAmount: [{required: true, message: '请获取网络费总金额', trigger: 'blur'}],
        // feeTypeEnumPaySubjectMap: [{required: true, validator: getFeeTypeEnumPaySubjectMap, trigger: 'change'}],
      },
      defaultDeposit: '',
      initDefaultDeposit: '',
      changeTag: false, // 是否弹出确认提示 解决bug
      // 押金倍数
      depositMultiples: [
        {
          id: '1.5',
          name: '1.5倍',
        },
        {
          id: '2',
          name: '2倍',
        },
      ]
    }
  },
  // props: ['businessTenantShow'],
  props: {
    businessTenantShow: {
      type: Boolean,
      default: false,
    },
    selectedList: {
      type: Array,
      default: () => {
        return []
      },
    },
    propertyInform: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: {
    EnergyForm,
    Manifest,
  },
  computed: {
    dateformat() {},
    totalPrice() {
      let total = ''
      if (this.businessFormData.selectedHouseList.length > 1) {
        total = this.businessFormData.selectedHouseList.reduce(
          (prices, item) => {
            return prices.monthPrice * 1 + item.monthPrice * 1
          }
        )
      } else if (this.businessFormData.selectedHouseList.length === 1) {
        total = this.businessFormData.selectedHouseList[0].monthPrice
      } else {
        total = 0
      }
      return total
    },
  },
  watch: {
    steps: function(val) {
      console.log(val, '810')
      if (val === 4) {
        const ids = this.businessFormData.selectedHouseList.map(
          el => el.houseSpaceId
        )
        let list = []
        houseApi.house.PerfeeAmountList(ids).then(res => {
          if (res.data.code === 200) {
            for (let key in res.data.data.successMap) {
              list.push({ code: key, name: res.data.data.successMap[key] })
            }
            console.log(list, '824')
            this.businessFormData.selectedHouseList.forEach(el => {
              list.forEach(item => {
                if (item.code === el.houseSpaceId) {
                  el.wyNum = item.name / 1000
                }
              })
            })
            this.businessFormData.perfeeTotalAmount = this.getNewPrices('wyNum')
          }
        })
      }
    },
    'businessFormData.startTime': function(val) {
      if (val) {
        this.firstMoneyMonth() // 获取 首月结束时间
      }
      if (this.businessFormData.timeRange) {
        this.getEndTime()
      }
    },
    'businessFormData.timeRange': function(val) {
      const a = filterCycleOptions(val)
      this.payCycle = a
      if (this.businessFormData.startTime) {
        this.getEndTime(res => {
          let endTime = res
          let { startTime, cycle, userId } = this.businessFormData
          if (startTime && endTime && cycle && this.selectedList.length) {
            let timeObj = { startTime, endTime, cycle, userId }
            this.getSaleRuleMessage(this.selectedList, timeObj)
          }
        })
      }
    },
    'businessFormData.cycle': function(val) {
      let { startTime, endTime, cycle, userId } = this.businessFormData
      if (startTime && endTime && cycle && this.selectedList.length) {
        let timeObj = { startTime, endTime, cycle, userId }
        this.getSaleRuleMessage(this.selectedList, timeObj)
      }
      console.log(val, '835')
      this.businessFormData.wyCycle = val
      //  this.businessFormData.wyCycle = this.businessFormData.timeRange
    },
    'businessFormData.selectedHouseList': function(val) {
      this.$refs.businessFormData.validateField('houseSelect')
      // this.$refs.businessFormData.validateField('houseChangedList')  // 当所选房源有改动时调动校验规则，重新校验
    },
    selectedList(val, oldValue) {
      if (val && val.length) {
        let { startTime, endTime, cycle, userId } = this.businessFormData
        if (startTime && endTime && cycle && userId) {
          let timeObj = { startTime, endTime, cycle, userId }
          if (!this.defaultDeposit) {
            this.getDefaultDeposit({zoneId: val[0].zoneId}).then(() => {
              this.getSaleRuleMessage(val, timeObj)
            })
          } else {
            this.getSaleRuleMessage(val, timeObj)
          }

        }
      }
    },
    propertyShow(val, oldValue) {
      if (!val) {
        this.businessFormData.selectedHouseList.forEach(item => {
          item.wyNum = '' // 删除 物管费信息
        })
        this.businessFormData.perfeeTotalAmount = ''
      }
    },
    netWorkShow(val, oldValue) {
      if (!val) {
        this.businessFormData.selectedHouseList.forEach(item => {
          item.wlNum = ''
        })
        this.businessFormData.netWorkTotalAmount = ''
      }
    },
    'defaultDeposit': {
      handler(val) {
        this.initDefaultDeposit = this.defaultDeposit + '';
        this.depositMultiples.push({
          id: this.defaultDeposit,
          name: `${this.defaultDeposit}倍`,
        })
        this.businessFormData.totalDepositProportion = this.defaultDeposit + ''
      }
    },

  },
  filters: {
    dateFormat,
  },
  methods: {
    loadList(houseSpaceId, item) {
      return new Promise(resolve => {
        listHouseAssets(houseSpaceId)
          .then(houseAssets => {
            console.log(houseAssets)
            item.articlesLists = houseAssets
          })
          .catch(err => {
            this.$message.error(err.message)
          })
          .finally(() => {
            resolve()
          })
      })
    },
    openJJ(item, i) {
      item.__visible['manifest'] = false
      item.__visible['energyForm'] = true
    },
    // 填写物品清单
    async openKK(item, i) {
      item.__visible['energyForm'] = false
      // get data by houseId
      if (item.articlesLists === null || item.articlesLists.length === 0) {
        await this.loadList(item.houseSpaceId, item)
      }
      item.__visible['manifest'] = true
    },
    open(id) {
      this.visibility[id] = true
    },
    closeD(id) {
      this.visibility[id] = false
    },
    dealMoney(row, column, cellValue) {
      if (cellValue === null) {
        return '—'
      } else if (column.property === 'monthPrice') {
        return `${cellValue}元/月`
      }
      return `${cellValue}元`
    },
    close() {
      this.$emit('closeBusinessTenantForm')
    },
    companyInformSearch(queryString) {
      if (queryString !== '') {
        this.companyLoading = true
        clearTimeout(this.waiter)
        this.waiter = setTimeout(() => {
          let str = queryString.replace(/^\s*|\s*$/g, '')
          let params = { keyword: str }
          accountApi.getCompanyList(params).then(res => {
            this.companyLoading = false
            if (res.data.code === 200) {
              this.options4 = res.data.data
            } else {
              this.options4 = []
              // this.$message.info('暂无该企业信息，请先新增该企业')
              // this.businessFormData.userName = ''
            }
          })
        }, 500)
      }
    },
    // 加工能耗费支付方数据结构
    dealWithFeeTypeEnumPaySubjectMap(val) {
      if (val === 'SIGNATORY') {
        let obj = { ENERGY: 'SIGNATORY' }
        return obj
      } else if (val === 'INPERSON') {
        let obj = { ENERGY: 'INPERSON' }
        return obj
      } else {
        return val
      }
    },
    companySelect(val, opts) {
      const item = opts.find(o => o.id === val)
      console.log({ currentItem: item })
      // 设置userName
      this.businessFormData.userName = item.username

      this.canCreate = true
      let selectedObj = this.options4.find(item => item.id === val)
      let {
        id,
        phone,
        certNumber,
        certType,
        userEnckosureBeans,
        legalName,
      } = selectedObj
      let urlArr = []
      if (userEnckosureBeans !== null) {
        userEnckosureBeans.forEach(item => {
          urlArr.push(item.addr)
        })
      } else {
        console.log('userEnckosureBeans is null.')
        this.errorMsg = '该企业未设置企业联系人，无法创建企业合同。'
        this.$message.warning(this.errorMsg)
        this.canCreate = false
      }
      this.tenantId = id
      this.businessFormData.userPhone = phone // 租客手机
      this.businessFormData.userId = id // 租客Id
      this.businessFormData.certificateNum = certNumber // 证件号
      this.businessFormData.certificateType = certType // 证件类型
      this.businessFormData.legalName = legalName // 法人姓名
      this.businessFormData.attachmentBean = {
        attachmentList: urlArr,
        attachmentType: 'CERTIFICATES',
      } // 照片链接
    },
    addNewCompany(val) {
      console.log('企业选项', this.options4)
      if (!this.canCreate) {
        this.$message.warning(this.errorMsg)
        return
      }

      let value = {}
      if (val === 'houseSelect') {
        let {
          startTime,
          endTime,
          timeRange,
          cycle,
          userId,
        } = this.businessFormData
        console.log(this.businessFormData)
        if (
          !this.tenantId ||
          !startTime ||
          !timeRange ||
          !cycle ||
          !endTime ||
          !userId
        ) {
          this.$message.warning('请先选择上述表单信息')
          return
        }
        value = {
          tenantId: this.tenantId,
          openType: val,
          tzEndTime: endTime
        }
        // 如果 已经选择部分房源，则将选择的片区和小区信息回填给房源选择页面
        let selectedHouseList = this.businessFormData.selectedHouseList
        let addressMessage = {}
        if (selectedHouseList.length) {
          addressMessage = {
            zoneId: String(selectedHouseList[0].zoneId),
            blockId: String(selectedHouseList[0].blockId),
            buildingNo: '',
            roomNo: '',
            isSelected: true,
          }
        } else {
          addressMessage = {
            zoneId: '',
            blockId: '',
            buildingNo: '',
            roomNo: '',
            isSelected: false,
          }
        }
        this.$emit(
          'zoneAndBlock',
          addressMessage,
          this.businessFormData.timeRange
        )
      } else if (val === 'addCompany') {
        value = {
          openType: val,
        }
      }
      this.$emit('openAddCompany', value)
    },
    // 房间号加工
    houseNumber(item) {
      if (item.rentType === 'ENTIRE_RENT') {
        return `${item.buildingNo}栋${item.roomNo}`
      } else if (item.rentType === 'JOINT_RENT') {
        return `${item.buildingNo}栋${item.roomNo}${item.houseSpaceName}`
      }
    },
    // 房源名称加工
    houseName(item) {
      if (item.rentType === 'ENTIRE_RENT') {
        return `${item.blockName}${item.buildingNo}栋${item.roomNo}`
      } else if (item.rentType === 'JOINT_RENT') {
        return `${item.blockName}${item.buildingNo}栋${item.roomNo}${item.houseSpaceName}`
      }
    },
    // 获取营销规则数据
    getSaleRuleMessage(houseList, timeObj) {
      if (Array.isArray(houseList) && houseList.length) {
        let houseIds = []
        houseList.forEach((item, index) => {
          let houseId = item.houseSpaceId
          houseIds.push(houseId)
        })
        let { startTime, endTime, cycle, userId } = timeObj
        let selectedHouseList = JSON.parse(JSON.stringify(this.selectedList))
        // selectedHouseList = selectedHouseList.concat(this.selectedList)
        let params = {
          // contractEndEnum: 'FD_END',
          contractId: userId,
          contractSignType: 'NEW',
          enumPayCycle: cycle,
          houseIds,
          isChangeContract: false,
          payEndTime: endTime,
          payStartTime: startTime,
          renterRoleEnum: 'COMMON',
        }
        saleRuleApi.rentPrice
          .getPayPriceOfMonthFromBusiness(params)
          .then(res => {
            if (
              res.data.code === 200 &&
              Array.isArray(res.data.data) &&
              res.data.data.length
            ) {
              let earnestArr = []
              selectedHouseList.forEach(tip => {
                let houseSpaceId = tip.houseSpaceId
                res.data.data.forEach(item => {
                  if (houseSpaceId === item.houseSpaceId) {
                    tip.depositByMonth = (
                      item.priceByPaymentResponse.depositByMonth / 1000
                    ).toFixed(0) // 押金
                    tip.firstCutPrice = (
                      item.priceByPaymentResponse.firstCutPrice / 1000
                    ).toFixed(0) // 首月减免
                    tip.firstCutDiscount =
                      item.priceByPaymentResponse.firstCutDiscount // 首月减免百分比
                    tip.monthPrice =
                      item.priceByPaymentResponse.monthPrice / 1000 // 月租金
                    tip.payCycleEnum = item.priceByPaymentResponse.payCycleEnum // 支付周期
                    tip.payWayEnum = item.priceByPaymentResponse.payWayEnum // 支付方式
                    tip.saleContentId = item.activitysId // 营销规则Id
                    tip.saleDescription = item.description // 营销规则描述
                  }
                })
                // 添加 实际签约价格， 租金差价， 实际首期减免 字段
                tip.articlesLists = [] // 物业交割数据
                tip.energyConsumption = [] // 能耗数据
                tip.actuallyMonthPrice = tip.monthPrice // 实际签约价格
                tip.monthPriceDiff = tip.monthPrice - tip.actuallyMonthPrice // 租金差价
                tip.actuallyFirstCutPrice = tip.firstCutPrice // 实际首期减免额
                tip.wyNum = 0 // 物管费月金额
                tip.wlNum = '' // 网络费月金额
                tip.wyCycle = '' // 物管费支付周期
                tip.wlCycle = '' // 网络费支付周期
                tip.rental = ''
                tip.livesNumber = '' // 最多可居住人数
                tip.reqChargInputLogBeanList = [] // 计费规则
                if (
                  tip.frontMoneyAmount !== null &&
                  tip.frontMoneyAmount !== undefined
                ) {
                  tip.frontMoneyAmount = tip.frontMoneyAmount / 1000 // 定金金额
                  earnestArr.push(tip.frontMoneyAmount)
                } else {
                  tip.frontMoneyAmount = null
                }
              })
              // 新添加的房源，获取其对应的营销规则后， 与原有选择房源进行合并，并且去重
              let totalSelectedHouseList = selectedHouseList.concat(
                this.businessFormData.selectedHouseList
              )
              // 去重
              let result = []
              let obj = {}
              for (let i of totalSelectedHouseList) {
                if (!obj[i.houseSpaceId]) {
                  result.push(i)
                }
                obj[i.houseSpaceId] = 1
              }
              this.businessFormData.selectedHouseList = result.map(
                extendHouseRow
              ) // 获取去重后的新值
              // axios
              this.businessFormData.blockName = selectedHouseList[0].blockName // 企业合同只能出租同一个社区的房源
              this.businessFormData.unitId = selectedHouseList[0].zoneId // 片区Id
              this.businessFormData.totalEarnest = earnestArr.length
                ? earnestArr.reduce((pic, kip) => {
                    return pic + kip
                  })
                : 0
              // 获取 总额相关数据
              this.getTotalPrices()
            }
          })
      } else {
        this.businessFormData.selectedHouseList = []
      }
    },
    // 根据 起租时间和租期时长 获取 退租时间
    getEndTime(callback) {
      let { startTime, timeRange } = this.businessFormData
      let params = {
        nowTime: startTime,
        value: timeRange,
        contractEndTimeType: 'MONTH',
      }
      contractApi.contract.getContractEndTime(params).then(res => {
        if (res.data.code === 200 && res.data.data) {
          // 退租时间不能是正月初一到正月初六
          // this.evadeSpringFestival(res.data.data)
          this.businessFormData.endTime = new Date(res.data.data)
          if (callback) {
            console.log(this.businessFormData.endTime)
            callback(this.businessFormData.endTime)
          }
        } else {
          this.businessFormData.endTime = ''
          this.$message.warning('获取不到退租时间')
        }
      })
    },
    // 判断退租时间是否是春节期间 rd468
    evadeSpringFestival(val) {
      // 考虑到如果阳历日期对应农历在同一年
      // 假如 退租时间 阳历是2023年12月30号 =  农历2023年12月17日  只对比2022年农历12月16日 到 2023年农历1月5日
      // 这样就会出现遗漏 修复 对比去年到今年 也对比今年到明年 钉钉同样
      let year = new Date(val).getFullYear() // 获取退租时间的年份
      // let lastyeartime = Lunar.toSolar(year - 1, 12, 16) // 获取上一年十二月16日 的阳历日期 格式 [year, month, day]
      let theyeartime = Lunar.toSolar(year, 1, 5) // 获取当年一月5日  的阳历日期 格式 [year, month, day]
      // let lasttheyeartime = Lunar.toSolar(year, 12, 16) // 获取今年十二月16日 的阳历日期 格式 [year, month, day]
      let thetomyeartime = Lunar.toSolar(year + 1, 1, 5) // 获取明年一月5日  的阳历日期 格式 [year, month, day]
      const { solarYear, solarMonth, solarDay } = calendar.lunar2solar(
        year - 1,
        12,
        16,
        false
      )
      const startTime = new Date(
        `${solarYear}-${solarMonth}-${solarDay}`
      ).getTime()
      // const startTime = new Date(`${lastyeartime[0]}-${lastyeartime[1]}-${lastyeartime[2]}`).getTime() // 获取开始时间戳
      const endTime = new Date(
        `${theyeartime[0]}-${theyeartime[1]}-${theyeartime[2]}`
      ).getTime() // 获取结束时间戳
      const {
        solarYear: solarYear1,
        solarMonth: solarMonth1,
        solarDay: solarDay1,
      } = calendar.lunar2solar(year, 12, 16, false)
      const startTime1 = new Date(
        `${solarYear1}-${solarMonth1}-${solarDay1}`
      ).getTime()
      // const startTime1 = new Date(`${lasttheyeartime[0]}-${lasttheyeartime[1]}-${lasttheyeartime[2]}`).getTime() // 获取开始时间戳
      const endTime2 = new Date(
        `${thetomyeartime[0]}-${thetomyeartime[1]}-${thetomyeartime[2]}`
      ).getTime() // 获取结束时间戳
      console.log({ startTime, endTime })
      console.log({ startTime1, endTime2 })
      // 2025-02-08
      // 暂时关闭签约结束时间落再过年期间限制
      // 2025-03-24
      // 打开签约结束时间落再过年期间限制
      // 2026-01-04
      // 暂时关闭签约结束时间落再过年期间限制
      // if (startTime <= Number(val) && Number(val) <= endTime) {
      //   this.$message('合同结束时间不符合规定，请重新选择签约周期')
      //   this.businessFormData.endTime = ''
      // } else if (startTime1 <= Number(val) && Number(val) <= endTime2) {
      //   this.$message('合同结束时间不符合规定，请重新选择签约周期')
      //   this.businessFormData.endTime = ''
      // } else {
        this.businessFormData.endTime = new Date(val)
      // }
    },
    // 拿第一个月的结束时间
    firstMoneyMonth() {
      this.$http
        .post(this.$store.state.contractUrl + 'getTime', {
          nowTime: this.businessFormData.startTime.getTime(),
          index: 1,
        })
        .then(
          function(response) {
            let data = response.data
            if (data.data !== null) {
              this.businessFormData.firstMonthEndTime = data.data
            } else {
              this.businessFormData.firstMonthEndTime = ''
            }
          },
          function(response) {
            console.log(response.status)
          }
        )
    },
    // 删除表格某个房间
    deleteRow(index, row) {
      this.$confirm('确定删除该房间吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        // this.selectedList.splice(index, 1) // 通过索引删除指定行数据
        this.businessFormData.selectedHouseList.splice(index, 1) // 通过索引删除指定行数据
        console.log(this.selectedList)
      })
    },
    // 获取初始 总价相关数据
    getTotalPrices() {
      let totalRuleRent = this.getNewPrices('monthPrice')
      let totalFirstCut = this.getNewPrices('firstCutPrice')
      this.businessFormData.totalRuleRent = totalRuleRent // 规则租金总价
      this.businessFormData.totalFirstCut = totalFirstCut // 规则首期总减免总额
      this.businessFormData.actulaTotalRuleRent = totalFirstCut // 初始 实际首期总减免额
      this.businessFormData.totalRental = totalRuleRent // 初始 实际租金总价
      this.businessFormData.rentDifferential = '0' // 初始 总租金差价
      this.businessFormData.rentDiscount = 100.0 // 初始 打折比例
      this.businessFormData.totalDepositProportion = this.defaultDeposit // 初始 押金收取比例
      let totalDeposit = parseFloat(
        totalRuleRent * this.defaultDeposit
      ).toFixed(1) // 实际 总押金额
      // this.businessFormData.totalDeposit = totalRuleRent // 初始 押金总额
      if (Number(this.defaultDeposit) === 1) {
        this.businessFormData.totalDeposit = totalDeposit// 初始 押金总额
      } else {
        this.businessFormData.totalDeposit = this.roundToNearestTen(totalDeposit) // 初始 押金总额
      }
    },
    // 获取实际总价相关数据
    getActuallyTotalPrices() {

      let totalRuleRent = this.businessFormData.totalRuleRent
      let totalDepositProportion = this.businessFormData.totalDepositProportion
      let actulaTotalRuleRent = this.getNewPrices('actuallyFirstCutPrice') // 实际首期减免
      let totalRental = this.getNewPrices('actuallyMonthPrice') // 实际租金总价

      let rentDifferential = parseFloat(totalRuleRent - totalRental).toFixed(0) // 实际 总租金差价
      let totalDeposit = parseFloat(
        totalRental * totalDepositProportion
      ).toFixed(1) // 实际 总押金额

      this.businessFormData.actulaTotalRuleRent = actulaTotalRuleRent
      this.businessFormData.totalRental = totalRental

      this.businessFormData.rentDifferential = rentDifferential
      if (Number(totalDepositProportion) === 1) {
        this.businessFormData.totalDeposit = totalDeposit
      } else {
        this.businessFormData.totalDeposit = this.roundToNearestTen(totalDeposit)
      }

    },
     // 点击押金倍率函数
     changeDepositConfirm(val) {
      let _this = this;
      // 取消再进来不弹框
      if (this.changeTag) {
        this.changeTag = false;
        return;
       }
      this.$confirm(`请确认押金=${val}倍租金`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.changeTag = false;
        _this.initDefaultDeposit = val
        _this.changeDeposit(val)
      }).catch(() => {
        _this.businessFormData.totalDepositProportion = _this.initDefaultDeposit
        _this.changeTag = true
      })

    },
    // 切换押金倍率
    changeDeposit(val) {
      let totalRental = this.getNewPrices('actuallyMonthPrice')
      if (Number(val) === 1) {
        this.businessFormData.totalDeposit = totalRental * val
      } else {
        this.businessFormData.totalDeposit = this.roundToNearestTen(totalRental * val)
      }
    },
    roundToNearestTen(num) {
      return Math.round(num / 10) * 10;
    },
    // 改变打折比例函数
    changeRentDiscount(e) {
      let rentDiscount = (e.target.value / 100).toFixed(4)
      this.businessFormData.rentDiscount = parseFloat(
        rentDiscount * 100
      ).toFixed(2)
      this.businessFormData.selectedHouseList.forEach(item => {
        console.log(item)
        item.actuallyMonthPrice = parseFloat(
          item.monthPrice * rentDiscount
        ).toFixed(0)
        item.monthPriceDiff = parseFloat(
          item.monthPrice - item.actuallyMonthPrice
        ).toFixed(0) // 更新更改项租金差价
        // this.$refs.businessFormData.validateField('houseSelected')  // 重新校验实际首减额
        // console.log(item.actuallyMonthPrice, rentDiscount, item.monthPriceDiff)
        // console.log(typeof (item.monthPrice), typeof (rentDiscount), typeof (item.monthPriceDiff))
        // console.log(item.monthPrice, rentDiscount)
      }) // 按比例动态改变所有房间的实际出租价格
      this.getActuallyTotalPrices() // 改变总额数据
    },
    // 修改单个实际签约价格函数
    changeActuallyMonthPrice(row, index) {
      // console.log(row, index)
      let actuallyMonthPrice = row.actuallyMonthPrice
      if (actuallyMonthPrice) {
        row.actuallyMonthPrice = Number(actuallyMonthPrice).toFixed(0) // 保留两位
      }
      this.getActuallyTotalPrices() // 改变总额数据
      row.monthPriceDiff = parseFloat(
        row.monthPrice - row.actuallyMonthPrice
      ).toFixed(0) // 更新更改项租金差价
      // console.log(typeof (row.monthPrice), typeof (row.actuallyMonthPrice))
      let rentDiscount = (
        (this.getNewPrices('actuallyMonthPrice') /
          this.businessFormData.totalRuleRent) *
        100
      ).toFixed(2) // 打折比例
      this.businessFormData.rentDiscount = rentDiscount // 打折比例
      // this.$refs.businessFormData.validateField('houseSelected')  // 重新校验实际首减额
    },
    // 修改 单个实际首期减免额函数
    changeActuallyFirstCutPrice(row, index) {
      let actuallyFirstCutPrice = row.actuallyFirstCutPrice
      if (actuallyFirstCutPrice) {
        row.actuallyFirstCutPrice = Number(actuallyFirstCutPrice).toFixed(0) // 保留两位
      }
      this.getActuallyTotalPrices()
    },
    // 点击显示物业清单
    addPropertyList(item, index) {
      let inform = {
        nenghaoMessage: item.energyConsumption,
        wuyeMessage: item.articlesLists,
        wuyeInform: {
          rentType: item.rentType,
          index: index,
        },
      }
      // console.log(inform)
      this.$emit('openAddCompany', { openType: 'property', inform: inform })
    },

    // 同步 修改显示函数
    changeShowPrice(val) {},
    // 同步 数据函数
    getNewPrices(val) {
      let priceArr = []
      let price = ''
      if (!this.businessFormData.selectedHouseList.length) {
        return 0
      }
      this.businessFormData.selectedHouseList.forEach(item => {
        priceArr.push(Number(item[val]))
      })
      price = priceArr.reduce((prices, item) => {
        return prices + item
      })
      return price.toFixed(2)
    },
    // 判断物业交割单是否有未填项
    checkArticlesLists() {
      let selectedHouseList = this.businessFormData.selectedHouseList
      return selectedHouseList.filter(item => !item.articlesLists.length)
    },
    // 调整房租
    adjustPrices() {
      // 更新 实际首期减免额
      this.adjustPrice = !this.adjustPrice
    },
    // 第四步 增加物管费
    addPropertyFee() {
      this.propertyShow = true
      // this.propertyShow = !this.propertyShow
    },
    addNetworkFee() {
      this.netWorkShow = !this.netWorkShow
    },
    // 改动物管费和网络费
    changeNum(row, val) {
      let priceNum = row[val]
      if (priceNum) {
        row[val] = Number(priceNum).toFixed(0) // 保留两位
      }
      if (val === 'wyNum') {
        console.log(this.getNewPrices('wyNum'))
        this.businessFormData.perfeeTotalAmount = this.getNewPrices('wyNum')
        console.log(this.businessFormData.perfeeTotalAmount)
      } else if (val === 'wlNum') {
        this.businessFormData.netWorkTotalAmount = this.getNewPrices('wlNum')
      }
    },
    // 改动网络费
    // changewlNum(item, index) {

    // },
    changeHouseKeeper(val) {
      console.log(val)
      let keeper = JSON.parse(this.$store.state.currentUser.keeperData)
      for (var i = 0; i <= keeper.length - 1; i++) {
        for (var j = 0; j <= keeper[i].cities.length - 1; j++) {
          if (val && val[1] === keeper[i].cities[j].label) {
            this.businessFormData.housekeeperId = keeper[i].cities[j].id
            this.businessFormData.housekeeperName = keeper[i].cities[j].label
            this.businessFormData.housekeeperPhone = keeper[i].cities[j].phone
            this.businessFormData.enterId = this.businessFormData.housekeeperId // 默认一致
          }
        }
      }
    },
    getDefaultDeposit ({zoneId}) {
      let $this = this;
      return saleRuleApi.rentPrice.getUnitWeight({unitId: zoneId, version: version})
        .then(
          function (response) {
            var data = response.data
            if (data.code === 200) {
              $this.defaultDeposit = Number(data.data) / 100
            } else {
              $this.$alert('请手动清完缓存之后再刷新', '获取押金利率失败', {
                confirmButtonText: '确定',
                callback: action => {
                  window.location.reload()
                }
              });
            }
          },
          function (response) {
            console.log(response.status)
          }
        )
    },

    // 回到上一步
    toLastStep(businessFormData) {
      // this.$refs.businessFormData.clearValidate()
      if (this.steps > 1) {
        this.steps--
      } else {
        return
      }
    },
    // 跳转到下一步
    toNextStep(val) {
      this.$refs[val].validate(valid => {
        if (valid) {
          if (this.steps === 3 && this.checkArticlesLists().length) {
            this.$message.warning('请确保物管交割清单都已添加')
            return
          } else if (
            this.steps === 3 &&
            isTableEditing(this.businessFormData.selectedHouseList)
          ) {
            // isTableEditing
            this.$message.warning('房源信息当前正在处于编辑状态，请先保存。')
            return
          } else if (this.steps === 3) {
            const err = validateWater.call(this)
            console.log(err)
            if (err) {
              this.$message.warning(err.message)
              return
            }
          } else if (this.steps === 1) {
            const { selectedHouseList: selectedList } = this.businessFormData
            console.log(selectedList.map(o => o.houseSpaceId))
            const ids = selectedList.map(o => o.houseSpaceId)
            let energyConfigList = []
            getConfigList(ids)
              .then(confList => {
                console.log({ confList })
                energyConfigList = confList
              })
              .finally(() => {
                this.opts = {
                  energyConfigList,
                }
              })
              if (!this.defaultDeposit) {
                this.getDefaultDeposit({zoneId: selectedList[0].zoneId})
              }
          }

          if (this.steps === 2 && !this.adjustPrice) {
            this.$message.warning('请先点击确认调整')
            return
          }
          if (this.steps < 4) {
            this.steps += 1
          } else if (this.steps === 4) {
            this.isLoading = true // 按钮禁用， 添加加载动画
            let houseAndConfigBeanList = [] // 子合同集合载体
            let {
              attachmentBean,
              blockName,
              certificateNum,
              certificateType,
              contractType,
              cycle,
              endTime,
              enterId,
              feeTypeEnumPaySubjectMap,
              housekeeperId,
              housekeeperName,
              legalName,
              housekeeperPhone,
              loginId,
              memo,
              rentDifferential,
              rentDiscount,
              signType,
              startTime,
              tenantType,
              timeRange,
              totalDeposit,
              totalFirstCut,
              totalRental,
              totalRuleRent,
              unitId,
              userId,
              userName,
              userPhone,
              selectedHouseList,
              totalEarnest,
              actulaTotalRuleRent,
              totalDepositProportion,
            } = this.businessFormData

            console.log({ businessFormData: this.businessFormData })
            selectedHouseList.forEach(item => {
              let obj = {}
              let {
                articlesLists,
                energyConsumption,
                houseSpaceId,
                actuallyMonthPrice,
                reservationId,
                monthPrice,
                actuallyFirstCutPrice,
                livesNumber,
              } = item
              let earnest =
                item.frontMoneyAmount === null ? 0 : item.frontMoneyAmount
              console.log(actuallyMonthPrice)
              // item.rental = actuallyMonthPrice  // 月租金
              // item.deposit = actuallyMonthPrice * totalDeposit  // 子合同房间押金

              // 计费规则
              let moneyRule = [
                {
                  chargType: 'REN',
                  businessType: 'RENT',
                  financeType: 'INC',
                  addType: 'NOTRISE',
                  endChargTime: this.businessFormData.endTime.getTime(),
                  initialAmount: actuallyMonthPrice * 1000,
                  startChargTime: this.businessFormData.startTime.getTime(),
                  addCycle: 'NORISE',
                  cycle: this.businessFormData.cycle, // 支付周期
                },
              ]
              // 存在网络费且有网络费支付周期写入计费规则
              if (this.businessFormData.wlCycle && item.wlNum) {
                moneyRule.push({
                  chargType: 'NETWORK',
                  businessType: 'RENT',
                  financeType: 'INC',
                  addType: 'NOTRISE',
                  endChargTime: this.businessFormData.endTime.getTime(),
                  initialAmount: item.wlNum * 1000,
                  startChargTime: this.businessFormData.startTime.getTime(),
                  addCycle: 'NORISE',
                  cycle: this.businessFormData.wlCycle, // 支付周期
                })
              }
              // // 存在物管费且有物管费支付周期写入计费规则
              let VM = true
              if (this.businessFormData.wyCycle || VM) {
                moneyRule.push({
                  chargType: 'PERFEE',
                  businessType: 'RENT',
                  financeType: 'INC',
                  addType: 'NOTRISE',
                  endChargTime: this.businessFormData.endTime.getTime(),
                  initialAmount: item.wyNum * 1000,
                  startChargTime: this.businessFormData.startTime.getTime(),
                  addCycle: 'NORISE',
                  cycle: this.businessFormData.wyCycle, // 支付周期
                })
              }
              if (item.actuallyFirstCutPrice) {
                // 第一个月的计费规则
                moneyRule.push({
                  chargType: 'REN',
                  businessType: 'RENT',
                  financeType: 'DISC',
                  addType: 'NOTRISE',
                  endChargTime: this.businessFormData.firstMonthEndTime,
                  initialAmount: item.actuallyFirstCutPrice * 1000,
                  startChargTime: this.businessFormData.startTime.getTime(),
                  addCycle: 'NORISE',
                  cycle: 'ONEMON', // 支付周期
                })
              }

              obj = {
                articlesLists,
                energyConsumption,
                houseSpaceId,
                firstCreditAmount: actuallyFirstCutPrice * 1000,
                earnest: earnest * 1000,
                ruleRent: monthPrice * 1000,
                rental: actuallyMonthPrice * 1000,
                childRentDifferential: (monthPrice - actuallyMonthPrice) * 1000,
                deposit: actuallyMonthPrice * totalDepositProportion * 1000,
                reqChargInputLogBeanList: moneyRule,
                reservationId,
                livesNumber: livesNumber,
              }
              houseAndConfigBeanList.push(obj)
            })
            let params = {
              totalEarnest: totalEarnest * 1000,
              actulaTotalRuleRent: actulaTotalRuleRent * 1000,
              attachmentBean,
              blockName,
              certificateNum,
              certificateType,
              contractType,
              cycle,
              legalName,
              endTime: endTime.getTime(),
              enterId,
              feeTypeEnumPaySubjectMap: this.dealWithFeeTypeEnumPaySubjectMap(
                feeTypeEnumPaySubjectMap
              ),
              houseAndConfigBeanList,
              housekeeperId,
              housekeeperName,
              housekeeperPhone,
              loginId,
              memo,
              rentDifferential: rentDifferential * 1000,
              rentDiscount,
              signType,
              startTime: startTime.getTime(),
              tenantType,
              timeRange,
              totalDeposit: totalDeposit * 1000,
              totalFirstCut: totalFirstCut * 1000,
              totalRental: totalRental * 1000,
              totalRuleRent: totalRuleRent * 1000,
              unitId,
              userId,
              userName,
              userPhone,
            }
            console.log(params)
            contractApi.contract.setBusinessContract(params).then(res => {
              console.log(res)
              if (res.data.code === 200) {
                this.$message.success(res.data.message)
                this.$emit('closeBusinessTenantForm')
              } else {
                this.$message.error(`企业合同创建失败。${res.data.message}`)
                this.isLoading = false
              }
            })
          }
        }
      })
      // }
    },
  },
  created() {
    this.$root.bus.$on('newPropertyInform', inform => {
      console.log(inform)
      let { articlesLists, energyConsumption, wuyeInform } = inform
      this.businessFormData.selectedHouseList[
        wuyeInform.index
      ].articlesLists = JSON.parse(JSON.stringify(articlesLists))
      this.businessFormData.selectedHouseList[
        wuyeInform.index
      ].energyConsumption = JSON.parse(JSON.stringify(energyConsumption))
      //  this.$forceUpdate()
      console.log(this.businessFormData.selectedHouseList)
    })

    this.addPropertyFee()
  },
  beforeDestroy() {
    // 注销其注册事件
    this.$root.bus.$off('newPropertyInform')
  },
}
</script>
<style lang="scss" scoped>
.business-tenant-form {
  width: 100%;
  // padding: 20px;
  box-sizing: border-box;
  .business-form {
    .step-content {
      width: 100%;
      .step-num {
        width: 650px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        color: #ffffff;
        position: relative;
        z-index: 1;
        .step-item {
          width: 40px;
          height: 40px;
          text-align: center;
          display: inline-block;
          line-height: 40px;
          border-radius: 50%;
          background-color: #3cbfc4;
        }
      }
      .step-words {
        width: 668px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        color: #ffffff;
        position: relative;
        z-index: 1;
        .step-word {
          font-size: 14px;
          line-height: 14px;
          color: #666666;
          display: inline-block;
          margin-top: 10px;
          text-align: center;
        }
      }
      .step-line {
        width: 650px;
        margin: 0 auto;
        position: relative;
        top: -45px;
        .line-item {
          border-bottom: 2px solid #56c7cb;
        }
      }
    }

    .form-content {
      margin-top: 60px;
      .form-line {
        width: 100%;
        .all-line {
          width: 100%;
          .inline-input {
            width: 100%;
          }
          .house-change-word {
            margin-left: 20px;
            display: inline-block;
            color: #fbb13f;
          }
        }
        .half-line {
          width: 100%;
          position: relative;
          .half-item {
            width: 100%;
          }
          .price-unit {
            position: absolute;
            top: 0;
            right: 11px;
          }
        }
        .table-line {
          width: 100%;
          .button-color {
            color: #e52d2d;
          }
          .total-info {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            .total-info-num {
              color: #3cbfc4;
              font-weight: bold;
            }
          }
          .adjust-button {
            width: 68px;
            height: 28px;
            text-align: center;
            font-size: 12px;
            box-sizing: border-box;
            padding: 0;
          }
          .price-input {
            width: 90px;
            // height: 26px;
          }
        }
        .new-company {
          display: inline-block;
          line-height: 36px;
          font-size: 14px;
          color: #3cbfc4;
          cursor: pointer;
        }
      }
      .separate-line {
        height: 0;
        border-bottom: 1px solid #e0e0e0;
        margin-bottom: 20px;
      }
      .step3-line {
        margin-left: 20px;
        height: auto;
        line-height: 56px;
        box-sizing: border-box;
        border-bottom: 1px solid #e0e0e0;
        .status-red {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #e52d2d;
          display: inline-block;
        }
        .status-green {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #3cbfc4;
          display: inline-block;
        }
        .status-word {
          margin-left: 4px;
          font-size: 14px;
          color: #666666;
          display: inline-block;
        }
      }
      .line-title {
        margin-left: 20px;
        height: 38px;
        box-sizing: border-box;
        line-height: 38px;
        font-weight: 500;
        color: #333333;
        border-bottom: 1px solid #e0e0e0;
      }
      .footer {
        margin: 50px 12px 0 0;
        text-align: right;
      }
    }
  }
}
</style>
<style>
.business-tenant-form .el-dialog {
  width: 1150px !important;
}
.business-tenant-form .step-content .is-text {
  width: 40px;
  height: 40px;
  font-size: 20px;
}
.business-tenant-form .step-content .el-step__icon {
  line-height: 38px;
}
.business-tenant-form .step-content .el-step__line {
  top: 18px;
  left: 38px;
}
.business-tenant-form .step-content .el-step__head.is-text.is-finish {
  background-color: #56c7cb;
  border-color: #56c7cb;
}
.business-tenant-form .step-content .el-step__title.is-finish {
  color: #56c7cb;
}

.business-tenant-form .all-line .el-form-item__content {
  width: 80%;
}
.business-tenant-form .half-line .el-form-item__content {
  width: 58%;
}
.business-tenant-form .table-line .el-form-item__content {
  width: 79%;
}
.business-tenant-form .table-line .el-input__inner {
  height: 26px;
}
.business-tenant-form .half-line .el-input__inner {
  padding-right: 45px;
}
.business-tenant-form .half-line .el-radio-button__inner {
  width: 106px;
}
.business-tenant-form
  .half-line
  .el-radio-button__orig-radio:checked
  + .el-radio-button__inner {
  background-color: #3cbfc4;
  border-color: #3cbfc4;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/BusinessContractForm/index.vue